import AgoraRTC, {CameraVideoTrackInitConfig, ILocalTrack, MicrophoneAudioTrackInitConfig} from "agora-rtc-sdk-ng";
import { audioTrackDefault, video480 } from "../agora/defaults";

export const releaseTrack = (track: ILocalTrack | null) => {
    if (track) {
        track?.stop();
        track?.removeAllListeners();
        track?.close();
    }
}

/**
 * Create local video track
 * @private
 */
export const createVideoTrack = async (config: CameraVideoTrackInitConfig = {}, videoDeviceId: string | undefined) => {
    try {
        return await AgoraRTC.createCameraVideoTrack(
            {
                ...video480,
                ...{
                    cameraId: videoDeviceId,
                },
                ...config
            });
    }
    catch (e) {
        return null;
    }
}

/**
 * Create local audio track
 */
export const createAudioTrack = async (config: MicrophoneAudioTrackInitConfig = {}, audioDeviceId: string | undefined) => {
    try {
        return await AgoraRTC.createMicrophoneAudioTrack({
            ...audioTrackDefault,
            ...{
                microphoneId: audioDeviceId
            },
            ...config
        });
    }
    catch (e) {
        return null
    }
}
